import {initModal, isMobile, setModalPosition, watchStack} from './stack-common';

const fetchData = (evt) => {
    evt.preventDefault();
    if(!!window.lb.blocks) {
        initModal(evt);
        const modalBody = document.getElementById('lb-stack-modal__body');
        const sidebar = document.getElementById('lb-stack-product');
        const target = !!evt.target.dataset.target ? evt.target.dataset.target : evt.target.parentElement.dataset.target;

        const h2 = window.lb.blocks[target].heading;
        const desc = window.lb.blocks[target].description;
        const button = window.lb.blocks[target].button;
        const url = window.lb.blocks[target].url;
        const html = `<h2>${h2}</h2><div>${desc}</div><div class="button__wrapper"><a href="${url}" class="button button--secondary">${button}</a></div>`;
        if (isMobile()) {
            sidebar.innerText = '';
            modalBody.innerHTML = html;
        }
        else {
            modalBody.innerText = '';
            sidebar.innerHTML = html;
        }
        setModalPosition();
    }
};

document.addEventListener('DOMContentLoaded', () => {

    watchStack(fetchData);

});
